import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNetworkWired, faScrewdriverWrench, faCloud } from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/Expertise.scss';

const expertiseAreas = [
  {
    icon: faCloud,
    title: "Cloud Infrastructure",
    description: "Designing and operating production AWS environments — multi-region, multi-AZ, with cost, performance, and compliance built in from the start.",
    tags: ["AWS EKS", "EC2 / ASG", "Aurora", "Karpenter", "Transit Gateway", "Route53", "FinOps", "Terraform"],
  },
  {
    icon: faScrewdriverWrench,
    title: "Platform Engineering",
    description: "Building the internal developer platform — GitOps pipelines, Helm chart libraries, OIDC-based CI/CD, and zero-touch deployment workflows.",
    tags: ["ArgoCD", "Helm", "GitOps", "GitHub Actions OIDC", "GitLab CI/CD", "Docker", "IRSA"],
  },
  {
    icon: faNetworkWired,
    title: "Security & Networking",
    description: "Custom Kubernetes networking, zero-trust patterns, PCI-DSS compliance, and Linux network engineering.",
    tags: ["Envoy", "CNI Plugins", "PCI-DSS", "WireGuard VPN", "Prometheus", "Grafana"],
  },
];

function Expertise() {
  return (
    <div className="container" id="expertise">
      <div className="expertise-container">
        <div className="expertise-header">
          <span className="expertise-tag">{'// Skills & Stack'}</span>
          <h1>Deep expertise, not buzzwords.</h1>
        </div>
        <div className="expertise-grid">
          {expertiseAreas.map((area, index) => (
            <div className="expertise-card" key={index}>
              <div className="expertise-icon">
                <FontAwesomeIcon icon={area.icon} />
              </div>
              <h2>{area.title}</h2>
              <p>{area.description}</p>
              <div className="expertise-tags">
                {area.tags.map((tag, i) => (
                  <span className="expertise-chip" key={i}>{tag}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Expertise;
